<template>
  <div class="qualification-prize-2020" @click="openDetailModal">
    <div class="qualification-prize-2020__img-container">
      <img
        :src="require(`@/assets/img/prizes/skins/${prize.img}`)"
        :alt="prize.name"
        class="qualification-prize-2020__img"
      />
    </div>
    <div class="qualification-prize-2020__infos">
      <h3 class="qualification-prize-2020__title">{{ prize.title }}</h3>
      <div class="qualification-prize-2020__description">
        {{ prize.titleDescr }}
      </div>
    </div>
  </div>
</template>

<script>
import { asyncModal } from "@/components/ui/modal/utils";
import PrizeDetailModal2020 from "./PrizeDetailModal2020";

export default {
  name: "QualificationPrize2020",
  props: {
    prize: {
      type: Object,
      required: true
    }
  },
  computed: {
    title() {
      return this.place + " место";
    }
  },
  methods: {
    openDetailModal() {
      asyncModal({
        name: "prize-detail-modal-2020",
        component: PrizeDetailModal2020,
        props: { prize: this.prize }
      });
    }
  }
};
</script>

<style lang="scss">
$p: ".qualification-prize-2020";

.qualification-prize-2020 {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Montserrat";
  text-shadow: 0px 10px 35px #000000;
  font-size: 21px;
  text-align: center;
  cursor: pointer;
  transition: text-shadow 0.3s;

  &:hover {
    text-shadow: 0 0 8px #fbc33e;
    #{$p}__img,
    #{$p}__img-container {
      filter: drop-shadow(0 0 15px #8d1111);
    }
  }

  &__img-container {
    width: 212px;
    height: 212px;
    background: url("~@/assets/img/prizes/circle.png") 50% 50% no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: filter 0.3s;
  }

  &__img {
    max-width: 100%;
    max-height: 100%;
    transition: filter 0.3s;
  }

  &__infos {
    height: 1.3em * 4;
  }

  &__title {
    font-weight: bold;
    line-height: 1.3;
    font-size: inherit;
  }

  &__description {
    line-height: 1.3;
    color: #fbc33e;
  }

  &__title,
  &__description {
    line-height: 1.3;
    max-height: 1.3em * 2;
  }

  @include breakpoint("sm-and-down") {
    font-size: 19px;
  }
}
</style>
